import { render, staticRenderFns } from "./KapaMonitoringSettings.vue?vue&type=template&id=655e94f1&scoped=true&"
import script from "./KapaMonitoringSettings.vue?vue&type=script&lang=js&"
export * from "./KapaMonitoringSettings.vue?vue&type=script&lang=js&"
import style0 from "./KapaMonitoringSettings.vue?vue&type=style&index=0&id=655e94f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e94f1",
  null
  
)

export default component.exports